import { Injectable, Inject, PLATFORM_ID, makeStateKey, StateKey, TransferState } from '@angular/core';
import { HttpClient } from '@angular/common/http';

import { isPlatformServer } from '@angular/common';
import { of } from 'rxjs';
import { tap } from 'rxjs/operators';

@Injectable({
  providedIn: 'root'
})
export class DataService {
  constructor(
    private http: HttpClient,
    private transferState: TransferState,
    @Inject(PLATFORM_ID) private platformId: Object
  ) { }

  getData(url: string) {
    const DATA_KEY: StateKey<string> = makeStateKey<string>(url);

    if (this.transferState.hasKey(DATA_KEY)) {
      const data = this.transferState.get(DATA_KEY, null);
      this.transferState.remove(DATA_KEY);
      return of(data);
    } else {
      return this.http.get(url).pipe(
        tap(data => {
          if (isPlatformServer(this.platformId)) {
            this.transferState.set(DATA_KEY, data as any);
          }
        })
      );
    }
  }
}
